import { twMerge } from 'tailwind-merge';

export function Label({
  htmlFor,
  children,
  className = '',
}: {
  htmlFor: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <label htmlFor={htmlFor} className={twMerge('font-aribaubold text-sm', className)}>
      {children}
    </label>
  );
}
